import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as storesAction from '../actions/store.actions';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {StoreService} from '../../store.service';



@Injectable()
export class StoreEffects {
  constructor(private actions: Actions, private storeService: StoreService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAllStores: Observable<Action> = this.actions.ofType(storesAction.GET_ALL_STORES)
    .pipe(
      switchMap(() => {
        return this.storeService.getAllStores()
          .map(res => new storesAction.GetAllStoresSuccess(res))
          .catch(error => of(new storesAction.GetAllStoresError(error)));
      })
    );

  @Effect()
  getStore: Observable<Action> = this.actions.ofType(storesAction.GET_STORE)
    .pipe(
      withLatestFrom(
        // select stores.
        this.store.select(state => state.storesFeature.stores.entities),
        (action: any, stores) => {
          // if no stores present, proceed for API.
          if (isNullOrUndefined(stores)) {
            return action;
          } else {
            // stores exists in store.
            const store = stores.filter(s => s.id === action.payload)[0];
            if (!!store) {
              // if required store is present in store, then return;
              return undefined;
            } else {
              // if required store not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.storeService.getStore(action.payload)
          .map(res => new storesAction.GetStoreSuccess(res))
          .catch(error => of(new storesAction.GetStoreError(error)));
      })
    );

  @Effect()
  registerStore: Observable<Action> = this.actions.ofType(storesAction.ADD_STORE)
    .map((action: storesAction.AddStore) => action.payload)
    .pipe(
      switchMap(body => {
        return this.storeService.registerStore(body)
          .map(res => new storesAction.AddStoreSuccess(res))
          .catch(error => of(new storesAction.AddStoreError(error)));
      })
    );

  @Effect()
  updateStore: Observable<Action> = this.actions.ofType(storesAction.UPDATE_STORE)
    .map((action: storesAction.UpdateStore) => action.payload)
    .pipe(
      switchMap(body => {
        return this.storeService.updateStore(body)
          .map(res => new storesAction.UpdateStoreSuccess(res))
          .catch(error => of(new storesAction.UpdateStoreError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store/effects/store.effects.ts